module.exports = __webpack_public_path__ + "static/funspark-69d91f88b8fe5cfb24476fc230fd26eb.png";